import { SidebarConversation } from "@rms-types/modules/conversation/types";

export function getUnreadMessageCount(conversation: SidebarConversation[]): number {
  return conversation.reduce((acc, conversation) => {
    acc += conversation.messages.filter((message) => !message.is_read).length;
    return acc;
  }, 0);
}
